<div
    class="var-app-light-dark:pb-8 orb-app-light-dark:pb-8 bg-grey-white_smoke dark:bg-contrast-black"
    [hidden]="isLoadingStop"
    ridangoAriaVisibilityObserver>
    <div *ngIf="!stop">
        <p class="empty-status-search-result__description">
            {{ 'EMPTY_STATUS_SEARCH_RESULT_NOT_FOUND' | translate }}
        </p>
    </div>
    <ng-template #stickyHeader>
        <rwidget-depart-filter
            *ngIf="stop"
            [(filterDepartTime)]="departTimeFilter"
            [routes]="routeFilterOptions"
            (filterRouteShortNamesChange)="handleRouteFilterChange($event)"
            (filterDepartTimeChange)="getData()">
            <div
                class="flex-align-center flex justify-between pb-4"
                [ngClass]="{
                    'pt-0': isMobileView,
                    'pt-1.5': !isMobileView
                }">
                <rwidget-bus-stop-header class="min-w-0 flex-1" [stop]="stop"></rwidget-bus-stop-header>
                <div class="mt-1 flex items-start self-start">
                    <ion-button
                        class="var-app-light:text-[#323232] orb-app-light:text-secondary my-0 h-8 w-8 dark:filter-yellow"
                        *ngIf="env.JOURNEY_PLANNER?.SHOW_SCHEDULE"
                        [attr.aria-label]="'EXPLORE_PLAN_JOURNEY_ARIA_LABEL' | translate"
                        (click)="scheduleClickHandle()"
                        slot="end"
                        fill="clear">
                        <ion-icon class="h-8 w-8" src="{{ assetsPath$ | async }}/img/explore/vector.svg"></ion-icon>
                    </ion-button>
                    <ion-button
                        class="var-app-light:text-[#323232] my-0 h-8 w-8 dark:filter-yellow"
                        *ngIf="env.EXPLORE?.SHOW_REFRESH_BUTTON"
                        [attr.aria-label]="'REFRESH' | translate"
                        (click)="refreshData()"
                        slot="end"
                        fill="clear">
                        <ion-icon
                            class="var-app-light-dark:text-primary h-8 w-8 text-secondary dark:filter-yellow"
                            title="{{ 'REFRESH' | translate }}"
                            aria-label="{{ 'REFRESH' | translate }}"
                            src="{{ assetsPath$ | async }}/img/journey-planner/icon-refresh.svg"></ion-icon>
                    </ion-button>
                    <ion-button
                        class="var-app-light:text-[#323232] my-0 h-8 w-8 text-secondary dark:filter-yellow"
                        #favoriteButton
                        *ngIf="env.EXPLORE?.SHOW_FAVORITE_STOPS"
                        [attr.aria-label]="isFavorite ? ('REMOVE_FAVORITE' | translate) : ('SAVE_FAVORITE' | translate)"
                        [attr.aria-checked]="isFavorite"
                        (click)="favoriteClickHandle()"
                        ridangoUpdateIonAria
                        slot="end"
                        role="switch"
                        fill="clear">
                        <ion-icon
                            class="h-8 w-8"
                            *ngIf="isFavorite"
                            src="{{ assetsPath$ | async }}/img/explore/favorite.svg"></ion-icon>
                        <ion-icon
                            class="h-8 w-8"
                            *ngIf="!isFavorite"
                            src="{{ assetsPath$ | async }}/img/explore/notFavorite.svg"></ion-icon>
                    </ion-button>
                    <ion-button
                        class="var-app-light:text-grey-zambezy my-0 h-8 w-8 dark:filter-yellow"
                        [attr.aria-label]="'CLOSE_ARIA_LABEL' | translate"
                        (click)="navigateBack()"
                        slot="end"
                        fill="clear">
                        <ion-icon class="h-8 w-8" src="{{ assetsPath$ | async }}/img/explore/cross.svg"></ion-icon>
                    </ion-button>
                </div>
            </div>
            <rwidget-caption
                class="[&:not(:last-of-type)]:mb-1"
                *ngFor="let message of disruptionMessages"
                [disruptionMessage]="message">
            </rwidget-caption>
        </rwidget-depart-filter>
    </ng-template>
    <div class="bg-grey-white_smoke dark:bg-contrast-black">
        <rwidget-departure-routes-list
            [showPatchSize]="numberOfDeparturesInList"
            [departTimeFilter]="departTimeFilter"
            [stop]="stop"
            [departures]="filteredDepartures"
            [isLoadingDepartures]="isLoadingDepartures"
            (departureSelect)="openTripDetailsView($event)"></rwidget-departure-routes-list>
    </div>
</div>

<div class="bg-white dark:bg-contrast-black" *ngIf="isLoadingStop || isLoadingDepartures">
    <div class="flex px-2 pt-2" *ngIf="isLoadingStop">
        <ridango-ui-skeleton-loader class="w-full" height="4rem" count="1"> </ridango-ui-skeleton-loader>
    </div>
    <div class="flex px-2" *ngIf="isLoadingStop || isLoadingDepartures">
        <ridango-ui-skeleton-loader class="w-full" height="1.5rem" count="1"> </ridango-ui-skeleton-loader>
    </div>
    <div class="flex px-2" *ngIf="isLoadingStop || isLoadingDepartures">
        <ridango-ui-skeleton-loader class="w-full" height="2.75rem" count="10"> </ridango-ui-skeleton-loader>
    </div>
</div>
